// Chat de Beni (agente de ElevenLabs en modo solo texto, interfaz propia). agentId vacío = chat desactivado.
// Vive aquí y no en services/config.ts para no mezclarlo con los bloques de entorno de ese fichero.
// El agente solo acepta conexiones desde los dominios de la app (allowlist en ElevenLabs).
export let BeniChat = {
    agentId: 'agent_1901m3vx8jhpezcbavmsxvsgbdt3',
    url: 'wss://api.elevenlabs.io/v1/convai/conversation',
    // Notas de voz: las transcribe la API de AsistencIA (solo acepta los dominios de la allowlist del agente).
    transcribeUrl: 'https://asistencia-api.tzpd00.easypanel.host/public/chat/:agentId/transcribe',
    maxSegundosAudio: 60
};
